import Button from "@storeblocks/button";
import HuseierneInline from "Static/svg/huseierne-inline.svg";
import Huseierne from "Static/svg/huseierne.svg";
import styled from "styled-components";

export const HuseierneBox = styled.div`
  border: 1px solid #191919;
  display: flex;
  flex-direction: row;
  margin-top: 48px;
  padding: 24px;
  width: 464px;

  @media screen and (max-width: 482px) {
    font-size: 14px;
    padding: 16px;
    width: 100%;

    & h4 {
      margin-top: 16px;
    }
  }

  @media screen and (max-width: 768px) {
    flex-direction: column-reverse;
  }
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  margin-right: 8px;
  max-width: 300px;

  @media screen and (max-width: 768px) {
    margin-right: 0;
    max-width: none;
  }
`;

export const HuseierneIcon = styled(Huseierne)`
  align-items: center;
  box-sizing: border-box;
  display: block;
  height: 80px;
  width: 130px;
`;

export const HuseierneInlineIcon = styled(HuseierneInline)`
  align-items: center;
  box-sizing: border-box;
  display: block;
`;

export const HuseierneOutlinedThemedButton = styled(Button)`
  border: 1px solid #004c3e;
  color: #004c3e;
  margin: 24px 0;

  @media screen and (max-width: 482px) {
    font-size: 14px;
    margin: 16px 0;
    padding: 4px;
  }
`;
